<template>
    <div class="preview-window">
        <v-container class="py-5 content-container">
            <!-- Кнопка "Назад" -->
            <v-layout row wrap class="back-link">
                <v-flex xs12 v-if="!showOfferLink">
                    <a @click="$emit('close-modal')"
                        class="back-button">
                        <v-icon class="mr-2">arrow_back</v-icon>
                        Назад к оформлению
                    </a>
                </v-flex>
                <v-flex xs12 v-else>
                    <a
                        href="/bp/list"
                        class="back-button">
                        <v-icon class="mr-2">arrow_back</v-icon>
                        Вернуться на главную
                    </a>
                </v-flex>
            </v-layout>

            <!-- Данные заемщика -->
            <div class="user-data-section">
                <h1 class="section-title">Данные заемщика</h1>
                <div class="user-info">
                    <div class="info-item">
                        <span class="info-label">ФИО</span>
                        <p class="info-value">{{ fullName }}</p>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Телефон</span>
                        <p class="info-value">{{ formattedPhone }}</p>
                    </div>
                    <div class="info-item">
                        <span class="info-label">Дата рождения</span>
                        <p class="info-value">{{ preparedFormData.birthDate }}</p>
                    </div>
                </div>
            </div>

            <!-- Выбранный оффер -->
            <div class="offer-section">
                <h2 class="section-title">Выбранный оффер</h2>
               <!-- Основные данные -->
                <div class="offer-details">
                    <div class="data-container">
                        <!-- Вознаграждение -->
                        <div class="data-item commission-item">
                            <div class="data-label">Вознаграждение, Р</div>
                            <div class="data-value">
                                {{ product.commission ? Number(product.commission).toFixed(0) : '-' }}
                            </div>
                        </div>
                        <!-- Динамические поля из extra_data -->
                        <template v-for="(value, key) in product.extra_data">
                            <div
                                v-if="value && value.name && value.value"
                                :key="key"
                                class="data-item"
                            >
                                <div class="data-label">{{ value.name }}</div>
                                <div class="data-value">{{ value.value }}</div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <!-- Ссылка на оффер -->
            <div v-if="showOfferLink && offerLink" class="offer-link-section">
                <div
                    class="offer-link"
                    @click="copyOfferLink"
                    @mouseleave="resetCopyState"
                >
                    <span class="link-text">{{ offerLink }}</span>
                    <span class="copy-status">
                        {{ copyStatus || 'Нажмите чтобы скопировать' }}
                    </span>
                </div>
            </div>
            <!-- Кнопки действий -->
            <div class="action-buttons">
                <v-btn
                    v-if="!showOfferLink"
                    @click="handleCalculate"
                    class="confirm-button"
                    block
                    large
                >
                    Всё верно!
                </v-btn>
                <v-btn
                    v-if="showOfferLink"
                    @click="redirectToBank"
                    class="redirect-button"
                    block
                    large
                >
                    Перейти к оформлению на сайт банка
                </v-btn>
                <button
                    v-if="!showOfferLink"
                    @click="$emit('close-modal')"
                    class="edit-button"
                    :disabled="showOfferLink ? true : false"
                >
                    Редактировать или выбрать другое предложение
                </button>
            </div>

        </v-container>
    </div>
</template>

<script>
export default {
    props: ['preparedFormData', 'product', 'offerLink'],
    data() {
        return {
            showOfferLink: false,
            copyStatus: '',
        };
    },
    computed: {
        fullName() {
            return `${this.preparedFormData.name} ${this.preparedFormData.surname} ${this.preparedFormData.patronymic}`
        },
        formattedPhone() {
            const phone = this.preparedFormData.phone;
            if (!phone) return '-';

            // Удаляем все нецифровые символы
            const cleaned = phone.toString().replace(/\D/g, '');

            // Проверяем и форматируем номер
            const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/);
            if (match) {
                return `+7-${match[2]}-${match[3]}-${match[4]}-${match[5]}`;
            }

            // Если номер не полный, возвращаем исходный
            return phone;
        }
    },
    methods: {
        handleCalculate() {
            this.$emit('calculate', this.product.id);
            this.showOfferLink = true;
        },
        redirectToBank() {
            if (this.offerLink) {
                window.open(this.offerLink, '_blank');
            } else {
                console.error('Ссылка на банк отсутствует');
            }
        },
        async copyOfferLink() {
            try {
                if (navigator.clipboard) {
                    await navigator.clipboard.writeText(this.offerLink);
                } else {
                    const textarea = document.createElement('textarea');
                    textarea.value = this.offerLink;
                    textarea.setAttribute('readonly', '');
                    textarea.style.position = 'absolute';
                    textarea.style.left = '-9999px';
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textarea);
                }
                this.copyStatus = 'Скопировано!';
            } catch (err) {
                this.copyStatus = 'Ошибка копирования';
                console.error('Ошибка при копировании:', err);
            }
        },
        resetCopyState() {
            this.copyStatus = '';
        }
    },
}
</script>

<style scoped>
.preview-window {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    z-index: 999;
    overflow-y: auto;
    padding: 20px;
}

.content-container {
    max-width: 1000px;
    margin: 0 auto;
}

.back-button {
    display: inline-flex;
    align-items: center;
    color: #00ba57;
    font-size: 1rem;
    text-decoration: none;
    padding: 16px 0;
    transition: opacity 0.3s;
}

.back-button:hover {
    opacity: 0.8;
}

.section-title {
    font-size: 1.8rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 2rem;
}

.user-data-section {
  margin-bottom: 40px;
  padding: 25px;
  background: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.offer-section {
  margin-bottom: 30px;
  padding: 25px;
  background: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.user-info {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    margin-bottom: 3rem;
}

.info-item {
    padding: 1.5rem 0;
}

.info-item .info-label {
    display: block;
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 0.5rem;
}

.info-item .info-value {
    font-size: 1.1rem;
    color: #333;
    margin: 0;
    font-weight: 500;
}

.offer-details {
    margin: 2rem 0;
}

.data-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
    width: 100%;
}

.data-item {
    display: flex;
    flex-direction: column;
    padding: 0;
    min-height: auto;
    background: none !important;
    box-shadow: none !important;
    border-radius: 0;
    transition: none;
}

.data-item:hover {
    box-shadow: none !important;
    transform: none !important;
}

.data-item .data-label {
    font-size: 13px;
    color: #666;
    margin-bottom: 4px;
    font-weight: 500;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.data-item .data-value {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
    word-break: break-word;
    overflow-wrap: break-word;
}

.action-buttons {
    margin-top: 3rem;
    display: grid;
    gap: 1.5rem;
}

.action-buttons .confirm-button {
    background: #00ba57 !important;
    color: white !important;
    font-weight: 600;
    height: 56px;
    border-radius: 50px;
    text-transform: none;
    letter-spacing: normal;
}

.action-buttons .redirect-button {
    background: #00ba57 !important;
    color: white !important;
    font-weight: 600;
    height: 56px;
    border-radius: 50px;
    text-transform: none;
    letter-spacing: normal;
}

.action-buttons .edit-button {
    border: 2px solid #c7c7c7;
    color: #333 !important;
    white-space: normal !important;
    word-break: break-word;
    font-weight: 500;
    height: 56px;
    border-radius: 50px;
    text-transform: none;
    letter-spacing: normal;
}

.action-buttons .edit-button:hover {
    border-color: #00ba57;
}

.offer-link-section {
    margin: 20px 0;
    text-align: center;
}

.offer-link {
    cursor: pointer;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: inline-block;
    max-width: 100%;
    transition: all 0.3s;
}

.offer-link:hover {
    background: #f5f5f5;
    border-color: #2196F3;
}

.link-text {
    display: block;
    word-break: break-all;
    color: #2196F3;
    text-decoration: none;
    font-weight: 500;
}

.copy-status {
    display: block;
    font-size: 0.8em;
    color: #666;
    margin-top: 4px;
    transition: color 0.3s;
}

.offer-link:hover .copy-status {
    color: #2196F3;
}



@media (max-width: 960px) {
  .user-data-section,
  .offer-section {
    padding: 20px;
  }
}

@media (max-width: 600px) {
  .user-data-section,
  .offer-section {
    padding: 16px;
    margin-bottom: 25px;
  }
}

@media (max-width: 480px) {
  .user-data-section,
  .offer-section {
    padding: 12px;
    margin-bottom: 20px;
  }
}

@media (max-width: 960px) {
    .section-title {
        font-size: 1.5rem;
    }

    .user-info {
        grid-template-columns: 1fr;
    }

    .data-container {
        grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
        gap: 12px;
    }

    .data-item .data-label {
        font-size: 12px;
    }

    .data-item .data-value {
        font-size: 15px;
    }
}

@media (max-width: 768px) {
    .action-buttons {
        margin-top: 2rem;
    }
}

@media (max-width: 600px) {
    .content-container {
        padding: 16px !important;
    }

    .back-button {
        font-size: 0.9rem;
    }

    .section-title {
        font-size: 1.3rem;
        margin-bottom: 1.5rem;
    }

    .v-btn__content {
        font-size: 14px !important;
    }

    .info-item {
        padding: 1rem 0;
    }

    .data-container {
        grid-template-columns: repeat(2, 1fr);
    }

    .data-item .data-label {
        font-size: 11px;
    }

    .data-item .data-value {
        font-size: 14px;
    }

    .action-buttons {
        gap: 1rem;
    }

    .action-buttons button {
        height: 48px !important;
        font-size: 0.9rem !important;
    }
}

@media (max-width: 480px) {
    .data-container {
        grid-template-columns: 1fr;
    }

    .data-item {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 8px 0;
        border-bottom: 1px solid rgba(0,0,0,0.05);
    }

    .data-item .data-label {
        margin-bottom: 0;
        margin-right: 10px;
        flex-shrink: 0;
        max-width: 50%;
    }

    .data-item .data-value {
        text-align: right;
        flex-grow: 1;
    }

    .commission-item {
        flex-direction: column;
        align-items: flex-start;
        border-bottom: none;
        padding: 0;
    }

    .commission-item .data-label {
        margin-bottom: 5px;
        margin-right: 0;
        max-width: 100%;
    }

    .commission-item .data-value {
        text-align: left;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/bank-products/banking-offers/BankingOfferPreview.vue